// src/pages/LoginPage.js
import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import '../../assets/css/login.css';
import { mainAssets } from'../../services/constant';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField from '@mui/material/TextField';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { useRouter } from '../../router/hooks/index';
import API_BASE_URL , {API_REGISTER} from '../../services/Config';

import { useGlobalContext } from '../../services/GlobalContext';
function LoginPage() {
    const [showPassword, setShowPassword] = React.useState(false);
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [password, setPassword] = useState('');
    const router = useRouter();
    const { setloading } = useGlobalContext();
    const handleClickShowPassword = () => {
        setShowPassword((show) => !show);
    }
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleEmailChange = (event) => {
        const value = event.target.value;
        setEmail(value);

        // Email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
            setEmailError('Por favor, insira um endereço de e-mail válido');
        } else {
            setEmailError('');
        }
    };
    const handlePasswordChanged = (e) => {
        const value = e.target.value;
        setPassword(value);
    }
    const handleSubmit = async (event) => {
        if (email === "" || password === "") {
            toast.error('Por favor, insira um endereço de e-mail ou senha', 'success');
            return;
        }
        setloading(true);
        axios.post(`${API_BASE_URL()}/v3/applications/af620e5c-dc3a-47e8-9976-7e673e0fb5f0/login` , {email: email, password: password} ,{ headers: {
            'Content-Type': ' application/json, text/plain, */*'
        }}).then((res) => {
            if(res.data?.user?.provider_state === 'active' || res.data?.user?.provideroperator_state === 'active') {
                toast.success("logado com sucesso");
                setloading(false);
                localStorage.setItem('authToken', res.data.user.access_token);
                localStorage.setItem('userData', JSON.stringify(res.data.user));
                router.push('/home');
            } else {
                window.location.href= API_REGISTER();
                // toast.error("o utilizador não está ativado");
                setloading(false);
            }
        }).catch((err) =>{
            toast.error(err?.response?.data?.text)
            setloading(false);
        })
    }
    return (
        <Container fluid className="login-page">
            <div className='d-flex w--100'>
                {/* Left Column - Image */}
                <div className='login-left'>
                    <img src={mainAssets.logo_bg} alt="Background Logo" className="bg" />
                </div>

                {/* Right Column - Login Form */}
                <div className="login-right mt-auto mb-auto">
                    <h2 className=" font-28-600 mb-8">LOG IN</h2>
                    <div className='mb-5 login_textField' >
                        <TextField
                            id="standard-basic"
                            label="Email*"
                            variant="standard"
                            fullWidth
                            className='font-15-600'
                            sx={{
                                '& input': {
                                    fontSize: '2rem', // Set font size for the input element
                                    width: '40.1rem'
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '1.5rem', // Optionally adjust label font size

                                }
                            }}
                            value={email}
                            onChange={handleEmailChange}
                            error={!!emailError} // Show error state if email is invalid
                            helperText={emailError} // Display error message
                            FormHelperTextProps={{
                                sx: { fontSize: '1.2rem' } // Customize font size for the error message
                            }}
                        />
                    </div>
                    <div className='login_textField'>
                        <FormControl variant="standard" sx={{width: '100%'}}>
                            <InputLabel htmlFor="standard-adornment-password" sx={{ fontSize: '1.5rem' }}>Password*</InputLabel>
                            <Input
                                id="standard-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                                
                                onChange={handlePasswordChanged}
                                sx={{ fontSize: '1.6rem', width: '100%' }}
                            />
                        </FormControl>
                    </div>
                    <div className="reset-text mb-5">
                        <a href={API_REGISTER() + '/recover'} className="text-warning ">Recuperação de password</a>
                    </div>

                    <div className='text-align-center mb-5'>
                        {
                            emailError === "" ?
                                (<Button type="submit" className="btn-block font-15-600 btn-color" onClick={() => handleSubmit()}> ENTRAR</Button>)
                                :
                                (<Button type="submit" className="btn-block font-15-600 btn-color" onClick={() => handleSubmit()} disabled> ENTRAR</Button>)
                        }

                    </div>

                    <div className="text-center regist-text font-15-600">
                        <p>Não tem conta? Efectue o <a href={API_REGISTER() + '/register?type=provider'} className="text-warning ">Registo</a></p>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" toastOptions={{
                style: {
                    fontSize:'1.5rem'
                },
            }} />
        </Container >
    );
}

export default LoginPage;
